import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const Headline = (props) => (
  <span {...props} className={cn(styles.headline, props.className)} />
);

Headline.propTypes = {
  className: PropTypes.string,
};

Headline.defaultProps = {
  className: '',
};

export default Headline;
